import type {
  ExpenseSettlementListRow,
  ExpenseSettlementsListQuery,
  ExpenseSettlementsListResult,
  ExpenseSettlementsSummary,
} from '../domain/expenseTypes';
import { EXPENSES_LIST_EXPORT_MAX_ROWS } from '../domain/expenseTypes';
import {
  countBranchSettlementsLocal,
  listBranchSettlementsLocal as queryBranchSettlementsLocal,
  summarizeBranchSettlementsLocal,
} from './expensesPullLocal';

export async function listBranchSettlementsLocal(
  query: ExpenseSettlementsListQuery
): Promise<ExpenseSettlementsListResult> {
  const base = {
    branchId: query.branchId,
    dateFrom: query.fromIso,
    dateTo: query.toIso,
    method: query.method ?? null,
    settlementStatus: query.status ?? 'active',
    search: query.search ?? null,
  };
  const [rows, total] = await Promise.all([
    queryBranchSettlementsLocal({
      ...base,
      limit: query.limit ?? 50,
      offset: query.offset ?? 0,
    }),
    countBranchSettlementsLocal(base),
  ]);
  return { rows, total };
}

export async function listBranchSettlementsExportLocalQuery(
  query: Omit<ExpenseSettlementsListQuery, 'limit' | 'offset'> & { maxRows?: number }
): Promise<{ rows: ExpenseSettlementListRow[]; truncated: boolean }> {
  const maxRows = query.maxRows ?? EXPENSES_LIST_EXPORT_MAX_ROWS;
  const base = {
    branchId: query.branchId,
    dateFrom: query.fromIso,
    dateTo: query.toIso,
    method: query.method ?? null,
    settlementStatus: query.status ?? 'active',
    search: query.search ?? null,
  };
  const [rows, total] = await Promise.all([
    queryBranchSettlementsLocal({
      ...base,
      limit: maxRows,
      offset: 0,
    }),
    countBranchSettlementsLocal(base),
  ]);
  return { rows, truncated: total > maxRows };
}

export async function summarizeBranchSettlementsLocalQuery(
  query: Omit<ExpenseSettlementsListQuery, 'limit' | 'offset'>
): Promise<ExpenseSettlementsSummary> {
  return summarizeBranchSettlementsLocal({
    branchId: query.branchId,
    dateFrom: query.fromIso,
    dateTo: query.toIso,
    method: query.method ?? null,
    settlementStatus: query.status ?? 'active',
    search: query.search ?? null,
  });
}
